module.exports = __webpack_public_path__ + "img/ex11.fbf66fa7.jpg";